import React from "react"
import {IconButton} from "@chakra-ui/react"
import {TrashIcon} from "@heroicons/react/24/solid"

import {IGroup} from "@backend/types"
import GroupSearch from "./GroupSearch"

export type PickedGroup = Pick<IGroup, "_id" | "title">

type GroupSelectProps = {
    groups?: PickedGroup[],
    onGroupsChange: (any) => void
}


export default function GroupSelect({groups = [], onGroupsChange}: GroupSelectProps) {

    function onGroupSelect(group) {
        const {_id} = group.data

        if (groups.findIndex(x => x._id === _id) === -1) {
            onGroupsChange({
                groups: [...groups, group.data]
            })
        }
    }

    function onGroupRemove(groupId: string) {
        onGroupsChange({groups: groups.filter(x => x._id !== groupId)})
    }

    return <div>
        <GroupSearch label="Group Search" onSelect={onGroupSelect}/>
        <ul role="list" className="divide-y divide-gray-100 mt-4">
            {groups.map((group) => (
                <li key={group._id.toString()} className="flex justify-between py-2">
                    <span className="text-sm text-gray-500">{group.title}</span>
                    <IconButton
                        variant="ghost" color="gray.500" aria-label="Remove Group"
                        onClick={onGroupRemove.bind(null, group._id)}
                        icon={<TrashIcon className="w-6 h-6"/>}/>
                </li>
            ))}
        </ul>
    </div>
}